import { FC, ReactNode, useState } from "react";
import { Spinner } from "@/lib/Components/Layout/Loaders/Spinner";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button, ButtonProps } from "@/components/catalyst/button";

export function IconButton({
  Icon,
  className,
  isLoading = false,
  tooltip,
  onClick,
  ...props
}: {
  Icon: FC<any>;
  isLoading?: boolean;
  tooltip: ReactNode;
} & ButtonProps) {
  const [isInternalLoading, setInternalLoading] = useState(false);

  const showLoading = isLoading || isInternalLoading;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          plain
          type="button"
          {...(props as any)}
          onClick={async (e) => {
            e.stopPropagation();
            setInternalLoading(true);
            try {
              await onClick?.(e as any);
            } finally {
              setInternalLoading(false);
            }
          }}
          className={className}
        >
          {showLoading ? (
            <Spinner className={`size-5`} />
          ) : (
            <Icon className={`size-6`} />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
